import { useWheatCodePolling } from 'pages/Settings/Wheat/WheatCodes/hooks/useWheatCodePolling'

export const WithWheatPolling = ({
  children,
}: {
  children: React.ReactNode
}) => {
  useWheatCodePolling()
  return <>{children}</>
}
